import {ending} from "./ending";

const timer = document.querySelector('.timer');
let timerInterval;
let remainingTime = time;

export function startTimer() {
    timerInterval = setInterval(() => {
        remainingTime--;
        timer.innerHTML = formatTime(remainingTime);

        if (remainingTime === 0) {
            resetTimer();
            ending();
        }
    }, 1000);
}

export function resetTimer() {
    clearInterval(timerInterval);
}

function formatTime(time) {
    const remainingMinutes = Math.floor(time / 60);
    const remainingSeconds = time % 60;
    const formattedMinutes = String(remainingMinutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return formattedMinutes + ':' + formattedSeconds;
}